import React, { useCallback, useContext, useEffect, useState } from "react";
import { trackPromise } from "react-promise-tracker";
import { ProvidersDetails } from "../../../../../@types/components/provider.types";
import { ADMIN_DASHBOARD_HEADER } from "../../../../../constants/caption/dashboardHeader";
import { UIContext } from "../../../../../contexts";
import { api } from "../../../../../utils/api";
import useRouteParam from "../../../../../hooks/useRouteParam";
import DynamicInformationForm from "../../../../shared/dynamicInformationForm/DynamicInformationForm";
import { dateTimeZoneConverter } from "../../../../../utils/commonFunctions/date";
import { Tab, Tabs } from "@material-ui/core";
import a11yScrollableProps from "../../../../../constants/tabPanelProps/ayScrollableProps";
import "./providersInformation.scss";
import { useNavigate } from "react-router-dom";
import ExtractRouteParams from "../../../../../utils/commonFunctions/extractRouteParams";
import CreateIcon from "@material-ui/icons/Create";
import { Button } from "@material-ui/core";
import ProviderDetails from "../../members/memberDetails/claim/EOB/providerDetails/ProviderDetails";

const ProvidersInformation: React.FC = (): JSX.Element => {
	const [providersData, setProvidersData] = useState<ProvidersDetails>();
	const [providerDetailsForm, setProviderDetailsForm] = useState<ProvidersDetails[]>([]);
	const { setDashboardHeader, setProviderUI } = useContext(UIContext);

	const routeParam = ExtractRouteParams();
	const navigate = useNavigate();

	const queryProvidersTaxId = useRouteParam("tx");

	// const handleGetProviderDetails = useCallback(async (tax_id: string) => {
	// 	const providersDetails: ProvidersDetails = await trackPromise(
	// 		api.providers.getProviderDetailsByTaxId({ tax_id })
	// 	);
	// 	if (!providersDetails) alert("Something went wrong while Fetching!");

	// 	setProvidersData(providersDetails);
	// }, []);
	const handleGetProviderDetails = useCallback(
		async (tax_id: string) => {
			const providersDetails: ProvidersDetails = await trackPromise(
				api.providers.getProviderDetailsByTaxId({ tax_id })
			);
			if (!providersDetails) alert("Something went wrong while Fetching!");

			setProvidersData(providersDetails);
			// Set provider information to the context
			setProviderUI({
				firstName: providersDetails.first_name,
				lastName: providersDetails.last_name,
				taxId: providersDetails.tax_id
			});
		},
		[setProviderUI]
	);

	const handleEditInformationClick = useCallback(() => {
		const pathname = `/employer/provider/edit-provider?${routeParam}`;
		navigate(pathname);
	}, [navigate, routeParam]);

	useEffect(() => {
		if (queryProvidersTaxId) handleGetProviderDetails(queryProvidersTaxId as string);
		setDashboardHeader(ADMIN_DASHBOARD_HEADER.provider_details);
	}, [handleGetProviderDetails, queryProvidersTaxId, setDashboardHeader]);

	useEffect(() => {
		providersData &&
			setProviderDetailsForm(
				Object.assign(
					[],
					[
						{
							label: "Tax Id",
							name: "tax_id",
							value: providersData.tax_id,
							type: "textfield"
						},
						{
							label: "First Name",
							name: "first_name",
							value: providersData.first_name,
							type: "textfield"
						},
						{
							label: "Middle Name",
							name: "middle_name",
							value: providersData.middle_name,
							type: "textfield"
						},
						{
							label: "Last Name",
							name: "last_name",
							value: providersData.last_name,
							type: "textfield"
						},
						{
							label: "Provider Type",
							name: "provider_type",
							value: providersData.provider_type,
							type: "textfield"
						},
						{
							label: "Provider Status",
							name: "provider_status",
							value: providersData.provider_status,
							type: "textfield"
						},
						{
							label: "Degree",
							name: "degree",
							value: providersData.degree,
							type: "textfield"
						},
						{
							label: "Speciality",
							name: "speciality",
							value: providersData.speciality,
							type: "textfield"
						},
						{
							label: "Contracted Through",
							name: "contracted_through",
							value: providersData.contracted_through,
							type: "textfield"
						},
						{
							label: "Fax Number",
							name: "fax_number",
							value: providersData.fax_number || "Null",
							type: "textfield"
						},
						{
							label: "Facility Name",
							name: "facility_name",
							value: providersData.facility_name,
							type: "textfield"
						},
						{
							label: "Fee Schedule",
							name: "fee_schedule",
							value: providersData.fee_schedule,
							type: "textfield"
						},
						{
							label: "Office Name",
							name: "office_name",
							value: providersData.office_name || "Null",
							type: "textfield"
						},
						{
							label: "Effective Date",
							name: "effective_date",
							value: dateTimeZoneConverter(providersData.effective_date),
							type: "textfield"
						},
						{
							label: "Termination Date",
							name: "termination_date",
							value:
								(providersData.termination_date &&
									dateTimeZoneConverter(providersData.termination_date)) ||
								"NULL",
							type: "textfield"
						},
						{
							label: "Phone Number",
							name: "phone_number",
							value: providersData.phone_number,
							type: "textfield"
						},
						{
							label: "Address",
							name: "address",
							value: providersData.address,
							type: "textfield"
						},
						{
							label: "State",
							name: "state",
							value: providersData.state,
							type: "textfield"
						},
						{
							label: "City",
							name: "city",
							value: providersData.city,
							type: "textfield"
						},
						{
							label: "ZIP",
							name: "ZIP",
							value: providersData.ZIP,
							type: "textfield"
						}
					]
				)
			);
	}, [providersData]);

	return (
		<div className="providers-status-information-container-main">
			<div className="providers-status-information-container">
				<div className="pf-action-button-container" id="pf-action-button-container">
					<Button className="button-black" onClick={handleEditInformationClick} variant="contained">
						<span className="button-label-with-icon">Edit</span>
						<span>
							<CreateIcon className="button-icon" />
						</span>
					</Button>
				</div>
				<span className="providers-status-text ">Providers Status: </span>

				{providersData?.provider_status === "ACTIVE" && (
					<span className="providers-status-active">{providersData?.provider_status}</span>
				)}
				{providersData?.provider_status === "TERMINATE" && (
					<span className="providers-status-inactive">{providersData?.provider_status}</span>
				)}
			</div>
			{providerDetailsForm ? <DynamicInformationForm informationFormData={providerDetailsForm} /> : null}
		</div>
	);
};

export default ProvidersInformation;
